// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "video[data-v-5283ac1f]{width:100%;height:100%;object-fit:cover}.video-wrapper[data-v-5283ac1f]{background-color:var(--color-primary)}\n", ""]);
// Exports
module.exports = exports;
